if (!customElements.get('locale-media-filter')) {
  class LocaleMediaFilter extends HTMLElement {
    constructor() {
      super();
      this.currentLocale = (window.Shopify && window.Shopify.locale) || 'fr';
    }

    connectedCallback() {
      this.applyLocaleFiltering();
      this.observeChanges();
    }

    applyLocaleFiltering() {
      const locale = this.currentLocale.toLowerCase();
      const mediaItems = this.querySelectorAll('.product__media-item');

      mediaItems.forEach(item => {
        const isEnContainer = item.classList.contains('media--en-container');
        const imgEN = item.querySelector('.media--en');
        const imgFR = item.querySelector('.media--fr');

        if (locale === 'en') {
          if (isEnContainer && !imgEN && imgFR) {
            this.show(imgFR);
            this.hide(imgEN);
            return;
          }

          this.show(imgEN);
          this.hide(imgFR);

        } else {
          if (isEnContainer && !imgEN && imgFR) {
            this.show(imgFR);
            this.hide(imgEN);
            return;
          }

          this.show(imgFR);
          this.hide(imgEN);
        }
      });
    }

    show(el) {
      if (!el) return;
      el.style.display = '';
      el.removeAttribute('hidden');
      el.classList.remove('media-hidden');
    }

    hide(el) {
      if (!el) return;
      el.style.display = 'none';
      el.setAttribute('hidden', '');
      el.classList.add('media-hidden');
    }

    observeChanges() {
      const observer = new MutationObserver(() => {
        this.applyLocaleFiltering();
      });

      observer.observe(this, {
        childList: true,
        subtree: true
      });
    }

    updateLocale(newLocale) {
      this.currentLocale = newLocale;
      this.setAttribute('locale', newLocale);
      this.applyLocaleFiltering();
    }
  }

  customElements.define('locale-media-filter', LocaleMediaFilter);
}